module.exports = __webpack_public_path__ + "img/coupon-bg.0a881893.png";